<template>
    <transition :name="transition">
        <div v-if="show" ref="modal" :class="classes"  role="dialog" @mousedown.self.stop="close" @keyup.esc="close" aria-labelledby="modal">
            <div :class="['modal-dialog', dialog]" role="document">
                <div class="modal-content">
                    <div v-if="header" class="modal-header" :class="headerClass" :style="headerStyle">
                        <div class="modal-title bold">
                            <slot name="title">{{ title }}</slot>
                        </div>

                        <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close" @click.stop="close">
                            <span>&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <button v-if="!header" type="button" class="close noHeader" data-dismiss="modal" aria-label="Close" @click.stop="close">
                            <span>&times;</span>
                        </button>

                        <slot name="body"></slot>
                    </div>

                    <div v-if="footer" class="modal-footer">
                        <slot name="footer">
                            <button type="button" :class="cancelClass" @click.stop="close">{{ cancelText }}</button>
                            <button type="button" :class="okClass" @click.stop="ok">{{ okText }}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        props: {
            modalBody: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: 'Information'
            },
            dialog: {
                type: String,
                default: 'modal-lg'
            },
            transition: {
                type: String,
                default: 'fade'
            },
            customClass: {
                type: String,
                default: '' //heightAuto -> modal has no defined height // widthAuto -> modal width is decided by its content
            },
            header: {
                type: Boolean,
                default: true
            },
            headerClass: {
                type: String
            },
            headerStyle: {
                type: Object
            },
            footer: {
                type: Boolean,
                default: true
            },
            okText: {
                type: String,
                default: 'Save'
            },
            cancelText: {
                type: String,
                default: 'Cancel'
            },
            okClass: {
                type: String,
                default: 'btn yes'
            },
            cancelClass: {
                type: String,
                default: 'btn cancel'
            },
            disableAutoClose: {
                type: Boolean,
                default: false,
            },
            preventClose: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            ...mapGetters([
                'getModal',
            ]),
            classes: function() {
                return ['modal', this.customClass, ((this.show) ? 'modal-open' : '')];
            },
            show: function() {
                return true
                // var modal = this.getModal;
                //
                // return modal.show;
            }
        },
        created: function() {
            if (this.show) {
                document.body.classList.add('modal-open');
            }
        },
        beforeDestroy: function() {
            document.body.classList.remove('modal-open');
        },
        methods: {
            ...mapActions([
                'closeModal'
            ]),
            ok: function() {
                this.$emit('ok');
                this.close();
            },
            close: function(e) {
                if (this.preventClose) {
                    return false;
                }
				//Check if the click is hiting the scroll bar (clicking the scrollbar should NOT close the modal)
                if (e.offsetX > e.target.clientWidth || e.offsetY > e.target.clientHeight){
					// Clicked the scrollbar or the close button(dont know y the close button click event enteres here but hey... it is what it is)
                    if(e.currentTarget.id == 'close'){// if clicked close button -> close
                        this.$emit('closemodal');
                        if (this.disableAutoClose) {
                            this.$emit('close');
                        } else {
                            this.closeModal();
                        }
                    } else { // clicked scrobar -> do nothing
						this.eventHub.$emit('closeTargetModal');
						this.$emit('closemodal');
                        return false;
                    }
                } else {
                    this.$emit('closemodal');
                    if (this.disableAutoClose) {
                        this.$emit('close');
                    } else {
                        this.closeModal();
                    }
                }
            },
        },
    }
</script>

<style lang="scss">
    @import "../../../node_modules/bootstrap/scss/bootstrap-grid.scss";
    @import '../../assets/scss/_variables.scss';

    .modal {
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0,0,0, 0.45);

        .modal-header {

            min-height: 2rem;
            padding: 0 0 2rem;
            border: 0;

            .modal-title {
                display: block;
                width: 100%;

                > div {
                    display: block;
                    width: 100%;
                    text-align: center;
                }
            }
        }

        .close {
            float: none;
            position: absolute;
            top: 1rem;
            right: 1.5rem;
            font-size: 1.5rem;
            font-weight: 400;
            line-height: 1;
            color: $medium;
            text-shadow: none;
            opacity: 1;
            z-index: 1;

            &.noHeader{
                top: 15px;
            }
        }

        .modal-content {
            margin-top: 30px;
            margin-bottom: 30px;
            border: 0;
            color: $darker;
            border-radius: 5px;
            box-shadow: 0 0 10px 0 $dark;
            padding: 1.5rem 0 0 0;
            // max-height: 99vh;

            .wrapper {
                padding: 0 2.6rem;
            }
        }

        .modal-body {
            padding: 0;
            // height: 73vh;
            // overflow-y: auto;
            position: relative;
            // overflow: auto;

            > div {
                max-height: 100%;
            }

            .sidebar {
                background: $lighter;
                border-right: 1px solid $light;
            }
        }

        &.heightAuto .modal-body{
            height: auto !important;
        }

        &.widthAuto .modal-content{
            // width: fit-content;
            // margin-left: auto;
            // margin-right: auto;
        }

        .modal-footer {
            display: block;
            padding: 2rem 2.5rem 0;
            border: 0;
        }

        .modal-dialog {
            // height: 100vh;
            height: auto;
            max-height: 100vh;
            flex: 1;
            margin: 0 auto;
            // overflow: initial;
        }

        &.narrow {
            .modal-content .wrapper {
                padding: 0 1.6rem;
            }

            .modal-footer {
                padding: 0 1.5rem;
            }
        }

        &.dark-top {
            .modal-header {
                padding: 0 2rem 0.5rem;
                background-color: $darker;
                color: $lightest;

                h2 {
                    margin: 1.5rem 0 1rem;
                }

                h3 {
                    font-size: $font-size-normal;
                    margin-bottom: 1.5rem;
                }

                .close {
                    // top: 1.8rem;
                }

                .search {
                    .write {
                        text-align: left;
                        background: rgba(0, 0, 0, 0.25);
                        border: 0;
                        color: $dark;

                        input {
                            color: $dark;
                        }
                    }
                }
            }

            .modal-content {
                margin-top: 30px;
                margin-bottom: 30px;
                padding-top: 0;
                padding-bottom: 0;
                box-shadow: none;
                background: $lightest;
            }

            .modal-footer {
                background: $lighter;
                border-top: 1px solid $light;
                padding: 1rem 1.5rem 1rem;
                justify-content: flex-end;

                > div {
                    display: flex;
                    width: 100%;
                    justify-content: flex-end;
                }

                .btn {
                    margin-left: 1rem;
                }
            }
        }

        &.danger {
            .modal-header {
                background: $red;

                .close {
                    color: $lightest;
                }
            }
        }

        &.warn {
            .modal-header {
                background: $color-4;

                .close {
                    color: $lightest;
                }
            }
        }

        &.fluid {
            .modal-body {
                height: auto;

                > div {
                    height: auto;
                }
            }
        }
    }

    @include media-breakpoint-up(sm) {
        .modal-x-sm {
            max-width: 19rem;
        }

        .modal-sm {
            max-width: 30rem;
        }
    }

    @include media-breakpoint-up(xl) {
        .modal.dark-top {
            .modal-header {
                padding: 0 2rem 1rem;

                h2 {
                    margin: 1rem 0 0rem;
                }

                h3 {
                    margin-bottom: 1rem 0 0rem;
                }
            }
        }
    }

    @media only screen and (max-height: 800px) {
        .modal-header {
            padding: 1rem 2rem !important;
            h2{
                margin: 0 !important;
            }
            h3{
                margin: 0 !important;
            }
        }

        .modal-body{
            height: auto !important;
        }

        .modal-footer{
            padding: 0.5rem 1.5rem !important;

            button{
                margin-top: 0.5rem !important;
                margin-bottom: 0.5rem !important;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// Modal.vue?0a8674ac